import httpClient from "@plugins/http";

const check = () => {
  return httpClient.get(`/apis/user/2fa/check`);
};
const sendOTP = (email) => {
  return httpClient.post(`/apis/user/2fa/request`, email);
};
const resendOTP = (email) => {
  return httpClient.post(`/apis/user/2fa/resend`, email);
};

const authenticateOTP = (requestData) => {
  return httpClient.post(`/apis/user/2fa/authenticate`, "", {
    params: requestData,
  });
};

export default {
  check,
  sendOTP,
  resendOTP,
  authenticateOTP,
};
